var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"refund-management"},[_c('div',{staticClass:"component-container"},[_c('prepaid-credit',{attrs:{"records":_vm.addRecords,"orderData":_vm.orderData}}),_c('consumption-amount',{attrs:{"records":_vm.records,"orderData":_vm.orderData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }